import InfoModal from "./InfoModal";

class BusinessMap {
	constructor(dom) {
		this.dom = dom;
		this.filterBtns = dom.querySelectorAll(".bm-filter-btn");
		this.cards = dom.querySelectorAll(".business-map__card");
		this.activeFilter = "all";
		this.modal = new InfoModal();
	}

	init() {
		this.modal.init();
		this._bindFilters();
		this._bindReadMore();
	}

	_bindFilters() {
		this.filterBtns.forEach((btn) => {
			btn.addEventListener("click", () => {
				const filter = btn.dataset.filter;
				if (filter === this.activeFilter) return;
				this.activeFilter = filter;
				this._applyFilter(filter);
				this._updateFilterUI(btn);
			});
		});
	}

	_applyFilter(filter) {
		this.cards.forEach((card) => {
			if (filter === "all") {
				card.classList.remove("is-hidden");
			} else {
				const cardFilters = (card.dataset.filters || "").split(" ");
				card.classList.toggle("is-hidden", !cardFilters.includes(filter));
			}
		});
	}

	_updateFilterUI(activeBtn) {
		const isAll = activeBtn.dataset.filter === "all";
		this.filterBtns.forEach((btn) => {
			btn.classList.remove("is-active", "is-inactive");
			if (btn === activeBtn) {
				btn.classList.add("is-active");
			} else if (!isAll) {
				btn.classList.add("is-inactive");
			}
		});
	}

	_bindReadMore() {
		this.dom.querySelectorAll("[data-bm-read-more]").forEach((btn) => {
			btn.addEventListener("click", () => {
				const card = btn.closest("[data-location]");
				if (!card) return;
				try {
					const data = JSON.parse(card.dataset.location);
					this.modal.open(data);
				} catch (e) {}
			});
		});
	}
}

export default BusinessMap;
